var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        _vm.hasVoucher ? "app-main-content tab-query-page" : "tab-query-page"
      ]
    },
    [
      _c(
        "div",
        { staticClass: "tabs-container" },
        [
          _c(
            "el-tabs",
            {
              staticStyle: { width: "100%" },
              attrs: { type: "card" },
              model: {
                value: _vm.properties.activeTabName,
                callback: function($$v) {
                  _vm.$set(_vm.properties, "activeTabName", $$v)
                },
                expression: "properties.activeTabName"
              }
            },
            [
              _vm.showBatch
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_BatchProcessing"),
                        name: "batchPage"
                      }
                    },
                    [
                      _vm.showBatch
                        ? _c("batch-page", {
                            key: "batchPage",
                            ref: "batchPage",
                            attrs: { "account-set": _vm.accountSet }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm.jobQuery
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_Business"),
                        name: "jobQuery",
                        lazy: true
                      }
                    },
                    [
                      _vm.jobQueryIsShow
                        ? _c("query-job", {
                            key: "jobQuery",
                            ref: "jobQuery",
                            attrs: {
                              identify: "jobQuerySearchItem",
                              "view-source": "VoucherList",
                              "is-ext": _vm.isExt,
                              "account-set-key": _vm.accountSet.uuid,
                              "account-set-branch-id": _vm.accountSetBranchId,
                              "has-voucher": _vm.hasVoucher,
                              "show-total-group": _vm.showTotalGroup,
                              "job-states": _vm.jobStates,
                              "voucher-page": _vm.voucherPage,
                              "grid-config-module": "1803011",
                              "col-settings": _vm.colSettings,
                              "filter-charge": _vm.filterChargeForJob
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm.invoiceReceivable
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_ARInvoice"),
                        name: "invoiceReceivable",
                        lazy: true
                      }
                    },
                    [
                      _vm.invoiceReceivableIsShow
                        ? _c("query-invoice", {
                            key: "invoiceReceivable",
                            ref: "invoiceReceivable",
                            attrs: {
                              identify: "invoiceReceivableSearchItem",
                              "view-source": "VoucherList",
                              "is-ar": 1,
                              "is-ext": _vm.isExt,
                              "account-set-key": _vm.accountSet.uuid,
                              "account-set-branch-id": _vm.accountSetBranchId,
                              "has-voucher": _vm.hasVoucher,
                              "show-simple": false,
                              "invoice-no-state": 1,
                              "biz-data-type": _vm.INVOICE_RECEIVABLE,
                              "has-invoice-receivable-payable":
                                _vm.hasInvoiceReceivablePayable,
                              "grid-config-module": "1906051",
                              "col-settings": _vm.colSettings,
                              "input-date-start":
                                _vm.searchConditions.inputDateStart,
                              "input-date-end":
                                _vm.searchConditions.inputDateEnd
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "searchAreaHeader",
                                  fn: function() {
                                    return [
                                      _c("search-area-header", {
                                        attrs: {
                                          "page-mode":
                                            _vm.properties.activeTabName,
                                          "search-conditions":
                                            _vm.searchConditions
                                        }
                                      })
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              1090169233
                            )
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm.invoicePayable
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_APInvoice"),
                        name: "invoicePayable",
                        lazy: true
                      }
                    },
                    [
                      _vm.invoicePayableIsShow
                        ? _c("query-invoice", {
                            key: "invoicePayable",
                            ref: "invoicePayable",
                            attrs: {
                              identify: "invoicePayableSearchItem",
                              "view-source": "VoucherList",
                              "is-ar": 0,
                              "is-ext": _vm.isExt,
                              "account-set-key": _vm.accountSet.uuid,
                              "account-set-branch-id": _vm.accountSetBranchId,
                              "has-voucher": _vm.hasVoucher,
                              "show-simple": false,
                              "invoice-no-state": -1,
                              "biz-data-type": _vm.INVOICE_PAYABLE,
                              "has-invoice-receivable-payable":
                                _vm.hasInvoiceReceivablePayable,
                              "grid-config-module": "1906052",
                              "col-settings": _vm.colSettings,
                              "input-date-start":
                                _vm.searchConditions.inputDateStart,
                              "input-date-end":
                                _vm.searchConditions.inputDateEnd
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "searchAreaHeader",
                                  fn: function() {
                                    return [
                                      _c("search-area-header", {
                                        attrs: {
                                          "page-mode":
                                            _vm.properties.activeTabName,
                                          "search-conditions":
                                            _vm.searchConditions
                                        }
                                      })
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              1090169233
                            )
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm.billingReceivable
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_ARBill"),
                        name: "billingReceivable",
                        lazy: true
                      }
                    },
                    [
                      _vm.billingReceivableIsShow
                        ? _c("query-billing", {
                            key: "billingReceivable",
                            ref: "billingReceivable",
                            attrs: {
                              identify: "billingReceivableSearchItem",
                              "view-source": "VoucherList",
                              "is-ar": 1,
                              "is-ext": _vm.isExt,
                              "account-set-key": _vm.accountSet.uuid,
                              "account-set-branch-id": _vm.accountSetBranchId,
                              "has-voucher": _vm.hasVoucher,
                              "show-simple": false,
                              oversea: 1,
                              "clearing-state": _vm.clearingState,
                              "grid-config-module": "1909031",
                              "col-settings": _vm.colSettings,
                              "input-date-start":
                                _vm.searchConditions.inputDateStart,
                              "input-date-end":
                                _vm.searchConditions.inputDateEnd
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "searchAreaHeader",
                                  fn: function() {
                                    return [
                                      _c("search-area-header", {
                                        attrs: {
                                          "page-mode":
                                            _vm.properties.activeTabName,
                                          "search-conditions":
                                            _vm.searchConditions
                                        }
                                      })
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              1090169233
                            )
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm.billingPayable
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_APBill"),
                        name: "billingPayable",
                        lazy: true
                      }
                    },
                    [
                      _vm.billingPayableIsShow
                        ? _c("query-billing", {
                            key: "billingPayable",
                            ref: "billingPayable",
                            attrs: {
                              identify: "billingPayableSearchItem",
                              "view-source": "VoucherList",
                              "is-ar": 0,
                              "is-ext": _vm.isExt,
                              "account-set-key": _vm.accountSet.uuid,
                              "account-set-branch-id": _vm.accountSetBranchId,
                              "has-voucher": _vm.hasVoucher,
                              "show-simple": false,
                              oversea: 1,
                              "clearing-state": _vm.clearingState,
                              "grid-config-module": "1909032",
                              "col-settings": _vm.colSettings,
                              "input-date-start":
                                _vm.searchConditions.inputDateStart,
                              "input-date-end":
                                _vm.searchConditions.inputDateEnd
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "searchAreaHeader",
                                  fn: function() {
                                    return [
                                      _c("search-area-header", {
                                        attrs: {
                                          "page-mode":
                                            _vm.properties.activeTabName,
                                          "search-conditions":
                                            _vm.searchConditions
                                        }
                                      })
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              1090169233
                            )
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm.billingOversea
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_InternationalBill"),
                        name: "billingOversea",
                        lazy: true
                      }
                    },
                    [
                      _vm.billingOverseaIsShow
                        ? _c("query-billing", {
                            key: "billingOversea",
                            ref: "billingOversea",
                            attrs: {
                              identify: "billingOverseaSearchItem",
                              "view-source": "VoucherList",
                              "is-ar": -1,
                              "is-ext": _vm.isExt,
                              "account-set-key": _vm.accountSet.uuid,
                              "account-set-branch-id": _vm.accountSetBranchId,
                              "has-voucher": _vm.hasVoucher,
                              "show-simple": false,
                              oversea: 1,
                              "clearing-state": _vm.clearingState,
                              "grid-config-module": "1909033",
                              "col-settings": _vm.colSettings,
                              "input-date-start":
                                _vm.searchConditions.inputDateStart,
                              "input-date-end":
                                _vm.searchConditions.inputDateEnd
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "searchAreaHeader",
                                  fn: function() {
                                    return [
                                      _c("search-area-header", {
                                        attrs: {
                                          "page-mode":
                                            _vm.properties.activeTabName,
                                          "search-conditions":
                                            _vm.searchConditions
                                        }
                                      })
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              1090169233
                            )
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm.chargeReceipt
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_DomesticCollection"),
                        name: "chargeReceipt",
                        lazy: true
                      }
                    },
                    [
                      _vm.chargeReceiptIsShow
                        ? _c("query-actual-amount", {
                            key: "chargeReceipt",
                            ref: "chargeReceipt",
                            attrs: {
                              identify: "chargeReceiptSearchItem",
                              "view-source": "VoucherList",
                              "is-ext": _vm.isExt,
                              "account-set-key": _vm.accountSet.uuid,
                              "account-set-branch-id": _vm.accountSetBranchId,
                              "has-voucher": _vm.hasVoucher,
                              "show-simple": false,
                              ar: 1,
                              oversea: 0,
                              "biz-data-type": _vm.RECEIPT_INTERNAL,
                              "grid-config-module": "1910011",
                              "col-settings": _vm.colSettings,
                              "input-date-start":
                                _vm.searchConditions.inputDateStart,
                              "input-date-end":
                                _vm.searchConditions.inputDateEnd
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "searchAreaHeader",
                                  fn: function() {
                                    return [
                                      _c("search-area-header", {
                                        attrs: {
                                          "page-mode":
                                            _vm.properties.activeTabName,
                                          "search-conditions":
                                            _vm.searchConditions
                                        }
                                      })
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              1090169233
                            )
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm.chargePayment
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_DomesticPayment"),
                        name: "chargePayment",
                        lazy: true
                      }
                    },
                    [
                      _vm.chargePaymentIsShow
                        ? _c("query-actual-amount", {
                            key: "chargePayment",
                            ref: "chargePayment",
                            attrs: {
                              identify: "chargePaymentSearchItem",
                              "view-source": "VoucherList",
                              "is-ext": _vm.isExt,
                              "account-set-key": _vm.accountSet.uuid,
                              "account-set-branch-id": _vm.accountSetBranchId,
                              "has-voucher": _vm.hasVoucher,
                              "show-simple": false,
                              ar: 0,
                              oversea: 0,
                              "biz-data-type": _vm.PAYMENT_INTERNAL,
                              "grid-config-module": "1910012",
                              "col-settings": _vm.colSettings,
                              "input-date-start":
                                _vm.searchConditions.inputDateStart,
                              "input-date-end":
                                _vm.searchConditions.inputDateEnd
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "searchAreaHeader",
                                  fn: function() {
                                    return [
                                      _c("search-area-header", {
                                        attrs: {
                                          "page-mode":
                                            _vm.properties.activeTabName,
                                          "search-conditions":
                                            _vm.searchConditions
                                        }
                                      })
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              1090169233
                            )
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm.chargeReceiptForegin
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_OverseasCollection"),
                        name: "chargeReceiptForegin",
                        lazy: true
                      }
                    },
                    [
                      _vm.chargeReceiptForeginIsShow
                        ? _c("query-actual-amount", {
                            key: "chargeReceiptForegin",
                            ref: "chargeReceiptForegin",
                            attrs: {
                              identify: "chargeReceiptForeginSearchItem",
                              "view-source": "VoucherList",
                              "is-ext": _vm.isExt,
                              "account-set-key": _vm.accountSet.uuid,
                              "account-set-branch-id": _vm.accountSetBranchId,
                              "has-voucher": _vm.hasVoucher,
                              "show-simple": false,
                              ar: 1,
                              oversea: 1,
                              "biz-data-type": _vm.RECEIPT_FOREGIN,
                              "grid-config-module": "1910013",
                              "col-settings": _vm.colSettings,
                              "input-date-start":
                                _vm.searchConditions.inputDateStart,
                              "input-date-end":
                                _vm.searchConditions.inputDateEnd
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "searchAreaHeader",
                                  fn: function() {
                                    return [
                                      _c("search-area-header", {
                                        attrs: {
                                          "page-mode":
                                            _vm.properties.activeTabName,
                                          "search-conditions":
                                            _vm.searchConditions
                                        }
                                      })
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              1090169233
                            )
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm.chargePaymentForegin
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_OverseasPayment"),
                        name: "chargePaymentForegin",
                        lazy: true
                      }
                    },
                    [
                      _vm.chargePaymentForeginIsShow
                        ? _c("query-actual-amount", {
                            key: "chargePaymentForegin",
                            ref: "chargePaymentForegin",
                            attrs: {
                              identify: "chargePaymentForeginSearchItem",
                              "view-source": "VoucherList",
                              "is-ext": _vm.isExt,
                              "account-set-key": _vm.accountSet.uuid,
                              "account-set-branch-id": _vm.accountSetBranchId,
                              "has-voucher": _vm.hasVoucher,
                              "show-simple": false,
                              ar: 0,
                              oversea: 1,
                              "biz-data-type": _vm.PAYMENT_FOREGIN,
                              "grid-config-module": "1910014",
                              "col-settings": _vm.colSettings,
                              "input-date-start":
                                _vm.searchConditions.inputDateStart,
                              "input-date-end":
                                _vm.searchConditions.inputDateEnd
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "searchAreaHeader",
                                  fn: function() {
                                    return [
                                      _c("search-area-header", {
                                        attrs: {
                                          "page-mode":
                                            _vm.properties.activeTabName,
                                          "search-conditions":
                                            _vm.searchConditions
                                        }
                                      })
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              1090169233
                            )
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm.chargeReceiptPayment
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_PaidInOutOfPocket"),
                        name: "chargeReceiptPayment",
                        lazy: true
                      }
                    },
                    [
                      _vm.chargeReceiptPaymentIsShow
                        ? _c("query-actual-amount", {
                            key: "chargeReceiptPayment",
                            ref: "chargeReceiptPayment",
                            attrs: {
                              identify: "chargeReceiptPaymentSearchItem",
                              "view-source": "VoucherList",
                              "is-ext": _vm.isExt,
                              "account-set-key": _vm.accountSet.uuid,
                              "account-set-branch-id": _vm.accountSetBranchId,
                              "has-voucher": _vm.hasVoucher,
                              "show-simple": false,
                              ar: -1,
                              oversea: -1,
                              "biz-data-type": _vm.RECEIPT_PAYMENT,
                              "has-pre-receipt-payment":
                                _vm.hasPreReceiptPayment,
                              "has-charge-pre-payment": _vm.chargePrePayment,
                              "grid-config-module": "1910015",
                              "col-settings": _vm.colSettings,
                              "show-invoice-detail": true,
                              "show-bill-payment-detail": true,
                              "input-date-start":
                                _vm.searchConditions.inputDateStart,
                              "input-date-end":
                                _vm.searchConditions.inputDateEnd
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "searchAreaHeader",
                                  fn: function() {
                                    return [
                                      _c("search-area-header", {
                                        attrs: {
                                          "page-mode":
                                            _vm.properties.activeTabName,
                                          "search-conditions":
                                            _vm.searchConditions
                                        }
                                      })
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              1090169233
                            )
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm.chargePrePayment
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_Advance"),
                        name: "chargePrePayment",
                        lazy: true
                      }
                    },
                    [
                      _vm.chargePrePaymentIsShow
                        ? _c("query-actual-amount", {
                            key: "chargePrePayment",
                            ref: "chargePrePayment",
                            attrs: {
                              identify: "chargePrePaymentSearchItem",
                              "view-source": "VoucherList",
                              "is-ext": _vm.isExt,
                              "account-set-key": _vm.accountSet.uuid,
                              "account-set-branch-id": _vm.accountSetBranchId,
                              "has-voucher": _vm.hasVoucher,
                              "show-simple": false,
                              ar: -1,
                              oversea: -1,
                              "biz-data-type": _vm.RECEIPT_PAYMENT,
                              "pre-bank-slip-states": _vm.preBankSlipStates,
                              "grid-config-module": "1910016",
                              "col-settings": _vm.colSettings,
                              "input-date-start":
                                _vm.searchConditions.inputDateStart,
                              "input-date-end":
                                _vm.searchConditions.inputDateEnd
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "searchAreaHeader",
                                  fn: function() {
                                    return [
                                      _c("search-area-header", {
                                        attrs: {
                                          "page-mode":
                                            _vm.properties.activeTabName,
                                          "search-conditions":
                                            _vm.searchConditions
                                        }
                                      })
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              1090169233
                            )
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm.invoiceReceivablePayable
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_InvoiceAfterARAPOffset"),
                        name: "invoiceReceivablePayable",
                        lazy: true
                      }
                    },
                    [
                      _vm.invoiceReceivablePayableIsShow
                        ? _c("query-invoice", {
                            key: "invoiceReceivablePayable",
                            ref: "invoiceReceivablePayable",
                            attrs: {
                              identify: "invoiceReceivablePayableSearchItem",
                              "view-source": "VoucherList",
                              "is-ar": 1,
                              "is-ext": _vm.isExt,
                              "account-set-key": _vm.accountSet.uuid,
                              "account-set-branch-id": _vm.accountSetBranchId,
                              "has-voucher": _vm.hasVoucher,
                              "show-simple": false,
                              "invoice-no-state": -1,
                              "biz-data-type": _vm.INVOICE_RECEIVABLE_PAYABLE,
                              "has-invoice-receivable-payable":
                                _vm.hasInvoiceReceivablePayable,
                              "grid-config-module": "1906053",
                              "col-settings": _vm.colSettings,
                              "input-date-start":
                                _vm.searchConditions.inputDateStart,
                              "input-date-end":
                                _vm.searchConditions.inputDateEnd
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "searchAreaHeader",
                                  fn: function() {
                                    return [
                                      _c("search-area-header", {
                                        attrs: {
                                          "page-mode":
                                            _vm.properties.activeTabName,
                                          "search-conditions":
                                            _vm.searchConditions
                                        }
                                      })
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              1090169233
                            )
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm.preReceiptPayment
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_VoucherOfAdvance"),
                        name: "preReceiptPayment",
                        lazy: true
                      }
                    },
                    [
                      _vm.preReceiptPaymentIsShow
                        ? _c("query-actual-amount", {
                            key: "preReceiptPayment",
                            ref: "preReceiptPayment",
                            attrs: {
                              identify: "preReceiptPaymentSearchItem",
                              "view-source": "VoucherList",
                              "is-ext": _vm.isExt,
                              "account-set-key": _vm.accountSet.uuid,
                              "account-set-branch-id": _vm.accountSetBranchId,
                              "has-voucher": _vm.hasVoucher,
                              "show-simple": false,
                              ar: -1,
                              oversea: -1,
                              "biz-data-type": _vm.PRE_RECEIPT_PAYMENT,
                              "has-pre-receipt-payment":
                                _vm.hasPreReceiptPayment,
                              "has-charge-pre-payment": _vm.chargePrePayment,
                              "grid-config-module": "1910017",
                              "col-settings": _vm.colSettings,
                              "input-date-start":
                                _vm.searchConditions.inputDateStart,
                              "input-date-end":
                                _vm.searchConditions.inputDateEnd
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "searchAreaHeader",
                                  fn: function() {
                                    return [
                                      _c("search-area-header", {
                                        attrs: {
                                          "page-mode":
                                            _vm.properties.activeTabName,
                                          "search-conditions":
                                            _vm.searchConditions
                                        }
                                      })
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              1090169233
                            )
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm.preReceiptPaymentClear
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_WriteOffOfAdvance"),
                        name: "preReceiptPaymentClear",
                        lazy: true
                      }
                    },
                    [
                      _vm.preReceiptPaymentClearIsShow
                        ? _c("query-actual-amount", {
                            key: "preReceiptPaymentClear",
                            ref: "preReceiptPaymentClear",
                            attrs: {
                              identify: "preReceiptPaymentClearSearchItem",
                              "view-source": "VoucherList",
                              "is-ext": _vm.isExt,
                              "account-set-key": _vm.accountSet.uuid,
                              "account-set-branch-id": _vm.accountSetBranchId,
                              "has-voucher": _vm.hasVoucher,
                              "show-simple": false,
                              ar: -1,
                              oversea: -1,
                              "biz-data-type": _vm.PRE_RECEIPT_PAYMENT_CLEAR,
                              "has-pre-receipt-payment":
                                _vm.hasPreReceiptPayment,
                              "has-charge-pre-payment": _vm.chargePrePayment,
                              "grid-config-module": "1910018",
                              "col-settings": _vm.colSettings,
                              "input-date-start":
                                _vm.searchConditions.inputDateStart,
                              "input-date-end":
                                _vm.searchConditions.inputDateEnd
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "searchAreaHeader",
                                  fn: function() {
                                    return [
                                      _c("search-area-header", {
                                        attrs: {
                                          "page-mode":
                                            _vm.properties.activeTabName,
                                          "search-conditions":
                                            _vm.searchConditions
                                        }
                                      })
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              1090169233
                            )
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm.billPaymentQuery
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_PaymentRequest"),
                        name: "billPaymentQuery",
                        lazy: true
                      }
                    },
                    [
                      _vm.billPaymentQueryIsShow
                        ? _c("query-bill-payment", {
                            key: "billPaymentQuery",
                            ref: "billPaymentQuery",
                            attrs: {
                              identify: "billPaymentQuerySearchItem",
                              "view-source": "VoucherList",
                              "is-ext": _vm.isExt,
                              "account-set-key": _vm.accountSet.uuid,
                              "account-set-branch-id": _vm.accountSetBranchId,
                              "has-voucher": _vm.hasVoucher,
                              state: _vm.billPaymentState,
                              "show-simple": false,
                              "grid-config-module": "1908011",
                              "col-settings": _vm.colSettings,
                              "input-date-start":
                                _vm.searchConditions.inputDateStart,
                              "input-date-end":
                                _vm.searchConditions.inputDateEnd
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "searchAreaHeader",
                                  fn: function() {
                                    return [
                                      _c("search-area-header", {
                                        attrs: {
                                          "page-mode":
                                            _vm.properties.activeTabName,
                                          "search-conditions":
                                            _vm.searchConditions
                                        }
                                      })
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              1090169233
                            )
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm.receiptPaymentOffset
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_ReceiptPaymentOffset"),
                        name: "receiptPaymentOffset",
                        lazy: true
                      }
                    },
                    [
                      _vm.receiptPaymentOffsetIsShow
                        ? _c("query-actual-amount", {
                            key: "receiptPaymentOffset",
                            ref: "receiptPaymentOffset",
                            attrs: {
                              identify: "receiptPaymentOffsetSearchItem",
                              "view-source": "VoucherList",
                              "is-ext": _vm.isExt,
                              "account-set-key": _vm.accountSet.uuid,
                              "account-set-branch-id": _vm.accountSetBranchId,
                              "has-voucher": _vm.hasVoucher,
                              "show-simple": false,
                              ar: -1,
                              oversea: -1,
                              "biz-data-type": _vm.RECEIPT_PAYMENT_OFFSET,
                              "has-pre-receipt-payment":
                                _vm.hasPreReceiptPayment,
                              "grid-config-module": "1910019",
                              "col-settings": _vm.colSettings,
                              "show-invoice-detail": true,
                              "input-date-start":
                                _vm.searchConditions.inputDateStart,
                              "input-date-end":
                                _vm.searchConditions.inputDateEnd
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "searchAreaHeader",
                                  fn: function() {
                                    return [
                                      _c("search-area-header", {
                                        attrs: {
                                          "page-mode":
                                            _vm.properties.activeTabName,
                                          "search-conditions":
                                            _vm.searchConditions
                                        }
                                      })
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              1090169233
                            )
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm.invoicePayableOffset
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_InvoicePayableOffset"),
                        name: "invoicePayableOffset",
                        lazy: true
                      }
                    },
                    [
                      _vm.invoicePayableOffsetIsShow
                        ? _c("query-invoice", {
                            key: "invoicePayableOffset",
                            ref: "invoicePayableOffset",
                            attrs: {
                              identify: "invoicePayableOffsetSearchItem",
                              "view-source": "VoucherList",
                              "is-ar": 0,
                              "is-ext": _vm.isExt,
                              "account-set-key": _vm.accountSet.uuid,
                              "account-set-branch-id": _vm.accountSetBranchId,
                              "has-voucher": _vm.hasVoucher,
                              "show-simple": false,
                              "invoice-no-state": -1,
                              "biz-data-type": _vm.INVOICE_PAYABLE_OFFSET,
                              "has-invoice-receivable-payable":
                                _vm.hasInvoiceReceivablePayable,
                              "grid-config-module": "1906054",
                              "col-settings": _vm.colSettings,
                              "input-date-start":
                                _vm.searchConditions.inputDateStart,
                              "input-date-end":
                                _vm.searchConditions.inputDateEnd
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "searchAreaHeader",
                                  fn: function() {
                                    return [
                                      _c("search-area-header", {
                                        attrs: {
                                          "page-mode":
                                            _vm.properties.activeTabName,
                                          "search-conditions":
                                            _vm.searchConditions
                                        }
                                      })
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              1090169233
                            )
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }